(function ($) {
  const initializeBlock = function ($block) {
    function matchHeightFire() {
      $(".iconBoxes .iconBox-container .iconBox-icon").matchHeight({
        property: "min-height",
      });
    }
    matchHeightFire();

    $(window).bind("resize orientationchange", function () {
      matchHeightFire();
    });

    setTimeout(function () {
      matchHeightFire();
    }, 400);

    $(".iconBox.has-popup", $block).click(function (e) {
      e.preventDefault();
      const boxId = $(this).data("box-id");
      $($block)
        .find(".popupOverlay[data-box-id='" + boxId + "']")
        .addClass("active");
      $($block)
        .find(".popup[data-box-id='" + boxId + "']")
        .addClass("active");
      $("body").addClass("u-noScroll");
    });
  };

  $(document).ready(function () {
    $(".block--icon-boxes").each(function () {
      initializeBlock($(this));
    });
  });

  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=icon-boxes",
      initializeBlock
    );
  }
})(jQuery);
